import React from 'react';
import {useTranslation} from 'react-i18next';
import {Controller, useForm} from 'react-hook-form';
import {useParams, useNavigate} from 'react-router-dom';
import {useSnackbar} from 'notistack';
import {
  Box,
  Dialog,
  DialogContent,
  Divider,
  // FormControl,
  // FormControlLabel,
  // FormLabel,
  Grid,
  // Radio,
  // RadioGroup,
  Typography
} from '@mui/material';
import {CloseOutlined} from '@mui/icons-material';
import {LoadingButton} from '@mui/lab';

import {createNewPad} from '@shared/services/service-handlers/PrivateService';

import {APP} from 'src/styles/variables';
import {ContainerGrid} from './CreatePadOptionsScreenStyle';
import {
  DialogActionsButtonStyle,
  DialogTitleStyle,
  IconButtonDiv
} from '@modules/home/main/dashboard/DashboardStyles';
import TextInput from '@components/form/text-input/text-input/TextInput';
import {CreatePadOptions, dialogPopupInputFieldsData} from './Utils';
import SelectInput from '@components/form/select-input/SelectInput';
import {
  ApplicationScreenMainDiv,
  FormControlDiv
} from '@modules/home/main/pads/pads-view-page/PadViewPageStyle';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {
  BASE_APPLICATION,
  BASE_ROUTE,
  BASE_ROUTE_PAD,
  BASE_ROUTE_WIDGETS
} from 'src/routes/BaseRoute';

const CreatePadOptionsScreen = (): JSX.Element => {
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const params = useParams();
  const navigate = useNavigate();
  const [state, setState] = React.useState({
    showText: false,
    radioValue: '',
    dialogOpen: false,
    loader: false
  });
  const {
    // showText,
    // radioValue,
    loader
  } = state;

  const {
    handleSubmit,
    control,
    formState: {errors},
    // setValue,
    // trigger,
    reset
  } = useForm({
    mode: 'onChange'
    // resolver: yupResolver(createApplicationsSchema)
  });

  // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   // setValue((event.target as HTMLInputElement).value);
  //   setState(prevState => ({
  //     ...prevState,
  //     radioValue: (event.target as HTMLInputElement).value,
  //     dialogOpen:
  //       (event.target as HTMLInputElement).value === 'form' ? true : false
  //   }));
  // };

  // handle selectable onclick function
  const handlePadClick = () => {
    return setState(prevState => ({
      ...prevState,
      dialogOpen: true
    }));
  };

  const handleClose = () => {
    reset();

    setState((prevState: any) => ({
      ...prevState,
      dialogOpen: false,
      radioValue: ''
    }));
  };

  const onSubmit = async (data: any) => {
    try {
      setState(prevState => ({
        ...prevState,
        loader: true
      }));

      const payload = Object.assign(data, {
        application_id: params.application_id
      });

      const res = await createNewPad(payload);

      setState((prevState: any) => ({
        ...prevState,
        dialogOpen: false,
        loader: false
      }));
      enqueueSnackbar(res?.message, SnackBarConfig.getSuccess());

      navigate(
        `/${BASE_ROUTE}/${BASE_APPLICATION}/${params.application_id}/${BASE_ROUTE_PAD}/${res?.data?.id}/${BASE_ROUTE_WIDGETS}`
      );
    } catch (error: any) {
      setState((prevState: any) => ({
        ...prevState,
        dialogOpen: false,
        loader: false
      }));
      const {message}: any = error;
      enqueueSnackbar(message, SnackBarConfig.getError());
    }
  };

  const renderStaticTabs = (data: any) => {
    return data.map((item: any) => {
      return (
        <ContainerGrid
          item
          borderColor={APP.PALETTE.TABS.GRAY}
          color={item?.color || APP.PALETTE.GREY.LIGHT_GRAY}
          key={item.id}
          onClick={() => (item.name === 'Blank' ? handlePadClick() : '')}
          sx={{
            '&:hover': {cursor: 'pointer'}
          }}>
          <Typography
            sx={{
              color: 'gray',
              fontWeight: '900'
            }}>
            {item.name}
          </Typography>
        </ContainerGrid>
      );
    });
  };

  const renderSelectFields = (
    inputName: string,
    item: any
  ): React.ReactElement => {
    return (
      <Controller
        name={inputName}
        control={control}
        defaultValue=""
        render={({field: {value, onChange}}) => (
          <FormControlDiv>
            <SelectInput
              enableDefaultOption
              options={[{value: 'AssignmentInd'}, {value: 'BrokenImage'}]}
              label={'Form Icon'}
              placeholder={'Form Icon'}
              name={inputName}
              value={value}
              fullWidth
              onChange={(event: any) => {
                onChange(event);
              }}
              optionValueKey={'value'}
              optionLabelKey={'value'}
            />
          </FormControlDiv>
        )}
      />
    );
  };

  const renderCreatePadButton = () => {
    return (
      <LoadingButton
        type="submit"
        variant="contained"
        loading={loader}
        sx={{
          backgroundColor: `${APP.PALETTE.MODULE_LAYOUT_COLOR.BUTTON}`,
          '&:hover': {
            backgroundColor: `${APP.PALETTE.MODULE_LAYOUT_COLOR.HOVER_BUTTON}`
          }
        }}>
        {t('PRIVATE.DASHBOARD.MODULE.CREATE_PAD', {ns: 'private'})}
      </LoadingButton>
    );
  };
  const renderCreateModuleDialog = () => {
    return (
      <Dialog
        fullWidth
        open={state?.dialogOpen}
        onClose={() => handleClose()}
        style={{borderRadius: '0.5'}}>
        <DialogTitleStyle>
          {t('PRIVATE.DASHBOARD.MODULE.MODULE_CREATE_FROM_STARCH', {
            ns: 'private'
          })}
          <Box>
            <IconButtonDiv onClick={() => handleClose()} disabled={loader}>
              <CloseOutlined />
            </IconButtonDiv>
          </Box>
        </DialogTitleStyle>

        <Divider style={{color: APP.PALETTE.GREY.LIGHT_GRAY}} />

        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            {dialogPopupInputFieldsData.map((item: any) => {
              return (
                <Grid item xs={12} key={item.name}>
                  <Controller
                    key={item.id}
                    name={item.name}
                    control={control}
                    render={({
                      field: {value, onChange},
                      fieldState: {error}
                    }) => {
                      return (
                        <TextInput
                          style={{width: '100%', marginBottom: '1rem'}}
                          // autoFocus
                          onChange={(event: any) => {
                            onChange(event);
                          }}
                          value={value}
                          name={item.name}
                          placeholder={item.label}
                          label={item.label}
                          error={!!errors[item.name]}
                          helperText={t(
                            `${
                              errors?.[item.name]
                                ? errors?.[item.name]?.message || ''
                                : ''
                            }`
                          )}
                          fullWidth
                          variant="outlined"
                        />
                      );
                    }}
                  />
                  {renderSelectFields('form_icon', '')}
                </Grid>
              );
            })}
          </DialogContent>

          <DialogActionsButtonStyle>
            {renderCreatePadButton()}
          </DialogActionsButtonStyle>
        </form>
      </Dialog>
    );
  };

  return (
    <ApplicationScreenMainDiv>
      <h4 style={{fontSize: 24, marginBottom: '0.5rem'}}>
        {t('PRIVATE.DASHBOARD.MODULE.HOW_WOULD_YOU_LIKE_TO_CREATE_YOUR_PAD', {
          ns: 'private'
        })}
      </h4>
      <div
        style={{display: 'flex', flexDirection: 'row', marginBottom: '2rem'}}>
        {renderStaticTabs(CreatePadOptions)}
      </div>
      {/* {showText && (
        <div>
          <FormControl>
            <FormLabel
              id="demo-controlled-radio-buttons-group"
              style={{fontSize: 18, color: 'black'}}>
              {t(
                'PRIVATE.DASHBOARD.MODULE.SELECT_THE_OPTION_TO_CREATE_YOUR_PAD',
                {
                  ns: 'private'
                }
              )}
            </FormLabel>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={radioValue}
              onChange={handleChange}>
              <FormControlLabel value="form" control={<Radio />} label="Form" />
              <FormControlLabel
                value="report"
                control={<Radio />}
                label="Report"
              />
            </RadioGroup>
          </FormControl>
        </div>
      )} */}
      {state?.dialogOpen ? renderCreateModuleDialog() : ''}
    </ApplicationScreenMainDiv>
  );
};

export default CreatePadOptionsScreen;
